<template>
    <section>
        <div v-if="!hasSelectedSection" class="sp-t-m">
            <p class="te-fat-light sm-b-m">{{ 'mead.settings' | athT }}</p>
            <DashboardConfigurationTabs :sections="allowedSections"
                :selectedSection="hasSelectedSection ? selected_section.section : ''"
                :config="internal_config"
                @onSelect="selectSection" />
        </div>
        <!-- MultiConfigDisplay version to show multiple configuration components -->
        <MultiConfigDisplay v-if="hasSelectedSection && isMultiSection"
            :lbl="selected_section.section_label"
            :children="selected_section.config_children"
            :config="internal_config"
            :dashboardType="dashboardType"
            :dashboard="dashboard"
            :widgetType="widgetType"
            :isV2MultiSection="isV2MultiSection"
            class="sp-t-m"
            @onUpdate="onUpdate"
            @onGoBack="goBack" />
        <!-- Section has a componnet key. This is being deprecated -->
        <comp v-else-if="hasSelectedSection && hasComponentKey"
            v-bind="selected_section.config"
            :is="sectionComponent"
            :config="internal_config"
            :dashboardType="dashboardType"
            :dashboard="dashboard"
            :widgetType="widgetType"
            class="sp-t-m"
            @onUpdate="onUpdate"
            @onGoBack="goBack" />
    </section>
</template>
<script>
import DashboardConfigurationControllerMixin from '../mixins/DashboardConfigurationControllerMixin';
import ButtonIcon from '../../../atoms/ButtonIcon.vue';

/**
 * This component is used to build section based configuration so that a dashboard
 * widget can have multiple configuration sections.
 *
 * This component and DashboardItemConfigExpanded.vue should be kept in sync.
 */
export default {
    mixins: [DashboardConfigurationControllerMixin],
    components: {ButtonIcon},
    methods: {
        goBack: function () {
            this.selected_section = false;
        },
    },
    created: function () {
        this.sendConfigUpdate(this.internal_config);
    },
};
</script>